export default {
  title: {
    welcome: 'Imagen de bono de bienvenida',
    app_signup: 'Imagen de bono de registro en la app',
  },
  select: {
    generate_title: 'Generar una imagen con IA',
    generate_subtitle: 'La crearemos basándonos en tu programa de cashback.',
    generate_cta: 'Generar',
    upload_link: 'o sube desde tu dispositivo',
    rate_limit_company: {
      title: 'Necesitamos un momento',
      description: 'Tu restaurante ha generado muchas imágenes esta hora. Inténtalo de nuevo en {{time}}.',
    },
    rate_limit_cashback_bonus: {
      title: 'Tomando un pequeño descanso',
      description: 'Parece que has intentado este bono varias veces seguidas. Estaremos listos en {{time}}.',
    },
  },
  generating: {
    title: 'Generando tu imagen…',
    progress: {
      cooking: 'Cocinando algo delicioso…',
      plating: 'Emplatando…',
      finishing: 'Añadiendo los últimos retoques…',
    },
  },
  preview: {
    alt: 'Imagen de bono generada',
    hint: '¿No es correcta? Regenera o continúa para recortar la imagen.',
    click_to_expand: 'Haz clic para ampliar',
    regenerate: 'Regenerar',
    continue: 'Continuar para editar',
  },
  toasts: {
    upload_success: 'Imagen subida correctamente.',
    upload_failed: 'Error al subir la imagen.',
    delete_success: 'Imagen eliminada correctamente.',
    delete_failed: 'Error al eliminar la imagen.',
    generate_success: 'Imagen generada correctamente.',
    generate_failed: 'Error al iniciar la generación de imagen.',
    generate_timeout: 'La imagen se está generando. Aparecerá aquí cuando esté lista.',
    rate_limit_company: 'Límite de imágenes por hora alcanzado. Inténtalo en {{time}}.',
    rate_limit_cashback_bonus: 'Demasiados intentos para este bono — inténtalo en {{time}}.',
  },
  time: {
    seconds_one: '1 segundo',
    seconds_other: '{{count}} segundos',
    minutes_one: '1 minuto',
    minutes_other: '{{count}} minutos',
    hours_one: '1 hora',
    hours_other: '{{count}} horas',
  },
};
